/* eslint-disable no-param-reassign */
export function removeIllegalCharacters(event: InputEvent, pattern) {
  // We need to add the global flag for the pattern to work
  const regex = new RegExp(`${pattern}`, 'g');
  const matched = (event.target as HTMLInputElement).value.toString().match(regex)?.find(el => el) ?? '';
  (event.target as HTMLInputElement).value = matched;
  return matched;
}

export function removeWhiteSpace(event: InputEvent) {
  const value = (event.target as HTMLInputElement).value.toString().replace(' ', '');
  (event.target as HTMLInputElement).value = value;
  return value;
}

export function removeNonAlphaNumericCharacters(event: InputEvent) {
  const value = (event.target as HTMLInputElement).value.toString().replace(/[^a-zA-Z0-9]/g, '');
  (event.target as HTMLInputElement).value = value;
  return value;
}

export function isNaNString(value: string): boolean {
  return new RegExp(`'[0-9]*'`, 'g').test(value)
}
